export default __webpack_public_path__ + "static/media/saveFilledIcon.2c70f0ac.svg";